// extracted by mini-css-extract-plugin
module.exports = {"container":"DescriptionLinks_container___mmgm"};